import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, ListGroup, Row, Col } from 'react-bootstrap';
import { useSessionStore } from '../../hooks/useSessionStore';
import { UsuarioContext } from '../../contexts/UsuarioContext';

const HorasBloqueadasList = (props) => {
    const { horasBloqueadas, onEliminar, ListaServicios } = props
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

    const [servicios, setServicios] = useState([]);
    const [HorasBloqueadas, setHorasBloqueadas] = useState([])

    const getListadoBloqueado = async (servicio_id) =>{
        await axios({
            method: 'GET',
            url: window.ipdirection + 'servicioEmpresaVacioEmpresa',
            headers: {
                Authorization: 'Bearer ' + Usuario.access,
            }
        }).then((response)=>{
            setHorasBloqueadas(response.data.filter((horas)=>horas.servicio_empresa===servicio_id))
        })
    }

    const seleccionarServicio = (nombre) => {
        console.log('nombre', nombre)
		// Iteramos sobre cada servicio en la lista de servicios.
		ListaServicios.map((servicio) => {
			// Verificamos si el nombre del servicio coincide.
			if (servicio.servicio_id.nombre === nombre) {
				// Actualizamos el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
				setServicios({...setServicios, ...servicio});

			}
		});
	};

    useEffect(()=>{
        if(servicios?.servicio_id){
            getListadoBloqueado(servicios.id)
        }
    }, [servicios])

    useEffect(()=>{
      console.log('ListaServicios', ListaServicios)
    },[])

  return (
    <div className="calendario-form">
      <h5 className="mb-3">Horas Bloqueadas</h5>
      <div className="mb-3">
        <label className="form-label">Servicio:</label>
        <select
          className="form-select text-dark"
          value={servicios.nombre}
          onChange={(e) => seleccionarServicio(e.target.value)}
        >
          <option value="">-- Seleccionar --</option>
          {ListaServicios &&
            ListaServicios.map((s, i) => (
              <option className="text-dark" key={i} value={s.servicio_id.nombre}>
                {s.servicio_id.nombre}
              </option>
            ))}
        </select>
      </div>
      {HorasBloqueadas.length === 0 ? (
        <div className="text-muted">No hay horarios bloqueados.</div>
      ) : (
        <ListGroup as="ul" variant="flush">
          {HorasBloqueadas.map((hora, index) => (
            <ListGroup.Item
              as="li"
              key={index}
              className="d-flex justify-content-between align-items-center"
            >
              <div>
                <div className="fw-bold">
                  {new Date(hora.fechaServicio).toLocaleDateString()} — {hora.hora_inicio}
                </div>
                <div className="text-muted small">Servicio: {servicios.servicio_id.nombre}</div>
              </div>
              {/* <Button
                variant="outline-danger"
                size="sm"
                onClick={() => onEliminar(index)}
              >
                <i className="bi bi-x-circle me-1"></i>Eliminar
              </Button> */}
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </div>
  );
};

export default HorasBloqueadasList;